<template>
  <section class="leaders__stat" :style="{ '--apperances-color': computedColor }">
    <div class="leaders__stat-item" >
      <div class="leaders__stat-numbers">
        {{ leader ? (leader.average_score ? leader.average_score : leader.average_total) : 'N/A' }}
      </div>
      <div class="leaders__stat-info">
        <span >
          {{ leader && leader.member_name ? leader.member_name : 'None Available' }} 
          ({{ leader && leader.total_runs ? leader.total_runs : 0 }} runs)
        </span>
        <small>Highest Average from {{ scores && scores.competitors_count ? scores.competitors_count : 0 }} competitors</small>
      </div>
    </div>
    <div class="leaders__stat-item">
      <div
        class="leaders__stat-numbers"
      >
        {{statistics.outsideScorePercentage}}%
      </div>
      <div class="leaders__stat-info">
        <span>Outside scores</span>
        <small>
          {{ scores && scores.outside_score_noms_count ? scores.outside_score_noms_count : 0 }} 
          out of {{ scores && scores.full_runs_count ? scores.full_runs_count : 0 }}
        </small>
      </div>
    </div>
    <div class="leaders__stat-item">
      <div
          class="leaders__stat-numbers"
      >
      {{statistics.courseScorePercentage}}%
      </div>
      <div class="leaders__stat-info">
        <span>Full courses</span>
        <small>
          {{ scores && scores.course_score_noms_count ? scores.course_score_noms_count : 0 }} 
          out of {{ scores && scores.full_runs_count ? scores.full_runs_count : 0 }}
        </small>
      </div>
    </div>
    <router-link
      v-if="cutoutRoute"
      :to="cutoutRoute"
      class="leaders__stat-item leaders__stat-max_cutout leaders__stat-item--link"
    >
      <div class="leaders__stat-numbers js-max_cutout__link">
        {{statistics.maxCutOut}}
      </div>
      <div class="leaders__stat-info">
        <span class="js-max_cutout__link">Highest cutout</span>
        <small>({{ scores && scores.cutout_max_count_noms ? scores.cutout_max_count_noms : 0 }})</small>
      </div>
    </router-link>
    <div v-else class="leaders__stat-item leaders__stat-max_cutout">
      <div class="leaders__stat-numbers js-max_cutout__link">
        {{statistics.maxCutOut}}
      </div>
      <div class="leaders__stat-info">
        <span class="js-max_cutout__link">Highest cutout</span>
        <small>({{ scores && scores.cutout_max_count_noms ? scores.cutout_max_count_noms : 0 }})</small>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  inject: {
    entity: { default: null }
  },
  props: {
    statistics: {
      type: Object,
      required: true
    },
    appearances: {
      type: Object,
      required: false
    }
  },
  computed: {
    leader() {
      return this.statistics.draftLeader || this.statistics.eventLeader || null
    },
    scores() {
      return this.statistics.draftScores || this.statistics.eventScores || null
    },
    computedColor() {
      return this.appearances && this.appearances.schema_color
        ? `${this.appearances.schema_color}65`
        : 'var(--primary-opasity)'
    },
    cutoutRoute() {
      if (!this.entity) return null
      if (this.entity.model === 'draft' && this.entity.id) {
        return {
          name: 'LeadersDraftCutoutHighest',
          params: { draft_id: this.entity.id }
        }
      }
      if (this.entity.model === 'event' && this.entity.event_id) {
        return {
          name: 'LeadersEventCutoutHighest',
          params: {
            event_id: this.entity.event_id,
            round: this.$route.params.round || 0
          }
        }
      }
      return null
    }
  }
}
</script>

<style scoped>
  .leaders__stat .leaders__stat-numbers {
    background-color: var(--apperances-color) !important;
  }

  .leaders__stat-item--link {
    text-decoration: none;
    color: inherit;
    cursor: pointer;
  }

  .leaders__stat-item--link:hover .leaders__stat-numbers {
    opacity: 0.85;
  }
</style>


// WEBPACK FOOTER //
// src/views/Leaders/Listing/components/Statistics.vue